import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ServerConn } from '../serverConn.service';

@Injectable({
    providedIn: 'root'
})
export class CriasService {

  data: any = [];
  length = 0;
  lact: any[] = [];
  @Output()
  needUpdate: EventEmitter<any> = new EventEmitter();
  selectedCEA = '';
  baseUrl = 'crias';

  constructor(private server: ServerConn) { }

  setCEA(cea) {
    this.selectedCEA = cea;
    console.log('🚀 ~ file: crias.service.ts ~ line 24 ~ CriasService ~ setCEA ~ this.selectedCEA', this.selectedCEA);
    this.needUpdate.emit(cea);
  }

  get(
    filterOrg: any,
    sort: string,
    start: number,
    limit: number,
    showBajas: boolean = false,
    withDistributions: boolean = false
  ): Observable<any> {
    console.log('🚀 ~ file: crias.service.ts ~ line 34 ~ CriasService ~ filterOrg', filterOrg);
    // if (!this.data.length) {
      const filter = [...filterOrg];
      const tablePrefix = showBajas ? 'bajas_crias.' : 'crias.';
      if (this.server.user.level >= 7 && this.selectedCEA > '') {
        console.log('🚀 ~ file: crias.service.ts ~ line 36 ~ CriasService ~ this.selectedCEA', this.selectedCEA);
        if (filter[0] && filter[0].color) {
          filter[0] = [filter[0]];
        }
        if (!filter[0]) {
          filter[0] = [];
        }
        filter[0].push({
          bitwise: '&&',
          field: tablePrefix + 'cea',
          dbfield: tablePrefix + 'cea',
          operation: '=',
          value: this.selectedCEA
        });
      }
      const params: any = {
        tblfilter: JSON.stringify(filter),
        tblorder: sort,
        tblstart: start,
        tbllimit: limit,
      };
      if (showBajas) {
        params.t = 'b';
      }
      if (withDistributions) {
        params.with_distributions = '1';
      }
      return this.server.get(
        this.baseUrl,
        params
      ).pipe(
        tap((res: any) => {
          const data = (typeof res.json !== 'undefined') ? res.json() : res;
          this.data = data;
        })
      );
    // } else {
    //   return of({
    //     result: true,
    //     data: {
    //       data: this.data
    //     }
    //   });
    // }
  }

  getCSV(
    filter: any,
    sort: string,
    showBajas: boolean = false
  ): any {
    // if (!this.data.length) {
      /**
       * Retornamos un
       */
      const params: any = {
        a: 'gcsv',
        tblfilter: JSON.stringify(filter),
        tblorder: sort,
      };
      if (showBajas) {
        params.t = 'b';
      }
      return this.server.download(
        this.baseUrl,
        params
      ).subscribe(
        (res: any) => {
          console.log(res);
          const keys = res.headers.keys();
          const headers = keys.map(key =>
              `${key}: ${res.headers.get(key)}`);
          console.log(headers);

          const blob = new Blob([res.body], { type: 'text/csv' });
          const filename = res.headers.get('File-Name');
          const element = document.createElement('a');
          element.href = window.URL.createObjectURL(blob);
          element.download = filename;
          document.body.appendChild(element);
          element.click();
          // window.open(url);
        }
      );
    // } else {
    //   return of({
    //     result: true,
    //     data: {
    //       data: this.data
    //     }
    //   });
    // }
  }

  getById(id, showBajas: boolean = false): Observable<any> {
      /**
       * Retornamos un
       */
      const params: any = {};
      if (showBajas) {
        params.t = 'b';
      }
      return this.server.get(
        this.baseUrl + '/' + id,
        params
      );
      // return data;
  }

  save(data: any): Observable<any> {
    return this.server.post(
      this.baseUrl,
      {
        d: JSON.stringify(data)
      }
    );
  }

  update(id, data: any): Observable<any> {
    return this.server.post(
      this.baseUrl + '/' + id,
      {
        d: data
      }
    );
  }

  delete(data: any): Observable<any> {
    return this.server.delete(
      this.baseUrl,
      {
        d: data
      }
    );
  }

  searchAdoptionAnimals(cea: string, q: string, sexo: string = ''): Observable<any> {
    return this.server.get(
      this.baseUrl + '/adopciones-pendientes/animals',
      {
        cea,
        q,
        sexo,
      }
    );
  }

  suggestPendingAdoption(id: number, boloMadre: string = ''): Observable<any> {
    return this.server.post(
      this.baseUrl + '/adopciones-pendientes/suggest',
      {
        d: JSON.stringify({
          id,
          bolo_madre: boloMadre,
        })
      }
    );
  }

  resolvePendingAdoptions(items: any[]): Observable<any> {
    return this.server.post(
      this.baseUrl + '/adopciones-pendientes/resolve',
      {
        d: JSON.stringify({
          items,
        })
      }
    ).pipe(
      tap((res: any) => {
        if (res && res.result) {
          this.needUpdate.emit(true);
        }
      })
    );
  }

  revive(ids: any[]): Observable<any> {
    return this.server.post(
      this.baseUrl + '/revive',
      {
        ids: ids
      }
    ).pipe(
      tap((res: any) => {
        if (res && res.result) {
          this.needUpdate.emit(true);
        }
      })
    );
  }

}
